/* USAGE 
Example: <ProgressBar value={30} max={100} />

Props:
  max - maximum value of the progress bar - OPTIONAL
  value - current value of the progress bar - can be 0 for empty - REQUIRED
*/

interface Props {
  max?: number;
  value: number;
  withNumber?: boolean;
}

export const WProgressBar = ({
  max = 100,
  withNumber = true,
  ...props
}: Props) => {
  return (
    <div className="flex items-center gap-3">
      {withNumber && (
        <div className="font-bold text-ekgreen">
          {props.value?.toFixed(props.value !== 0 ? 2 : 0)}%
        </div>
      )}

      <progress
        max={max}
        value={props.value}
        className="ek-progress"
      ></progress>
    </div>
  );
};

export default WProgressBar;
